import React from 'react'
import { Link, type LinkProps, Skeleton, styled } from '@mui/material'
import { GenericLoader } from '../GenericLoader'
import type { LoadingProps } from '../LoadingProps'

const H6Skeleton = styled(Skeleton)`
    height: 20px;
    margin: 6px 0;
`

interface LoaderLinkProps extends LoadingProps, Omit<LinkProps, 'width'> {}

export const LoaderLink: React.VFC<LoaderLinkProps> = ({
    loading,
    width,
    children,
    align,
    ...rest
}: LoaderLinkProps) => {
    let alignSkeleton: 'left' | 'center' | 'right' | undefined
    if (align === 'left' || align === 'center' || align === 'right') {
        alignSkeleton = align
    }

    return (
        <GenericLoader
            loading={loading}
            SkeletonComponent={H6Skeleton}
            skeletonProps={{ width }}
            alignSkeleton={alignSkeleton}
        >
            <Link {...rest} color="primary">
                {children}
            </Link>
        </GenericLoader>
    )
}
